import { BrowserRouter, Route, Routes } from 'react-router-dom';
import RequireAuth from './components/RequireAuth';
import { AuthProvider } from './contexts/AuthContext';
import DashboardLayout from './layouts/DashboardLayout';
import DashboardPage from './pages/DashboardPage';
import LandingPage from './pages/LandingPage';
import AnalyticsPage from './pages/AnalyticsPage';
import AutomationsPage from './pages/AutomationsPage';
import DmRulesPage from './pages/DmRulesPage';
import ExecutionLogsPage from './pages/ExecutionLogsPage';
import HighlightsPage from './pages/HighlightsPage';
import InboxPage from './pages/InboxPage';
import InstagramConnectPage from './pages/InstagramConnectPage';
import LoginPage from './pages/auth/LoginPage';
import NotFoundPage from './pages/NotFoundPage';
import PostsPage from './pages/PostsPage';
import RegisterPage from './pages/auth/RegisterPage';
import SettingsPage from './pages/SettingsPage';
import StoriesPage from './pages/StoriesPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/" element={<LandingPage />} />
          <Route element={<RequireAuth />}>
            <Route element={<DashboardLayout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/connect" element={<InstagramConnectPage />} />
              <Route path="/automations" element={<AutomationsPage />} />
              <Route path="/stories" element={<StoriesPage />} />
              <Route path="/posts" element={<PostsPage />} />
              <Route path="/highlights" element={<HighlightsPage />} />
              <Route path="/dm" element={<DmRulesPage />} />
              <Route path="/inbox" element={<InboxPage />} />
              <Route path="/logs" element={<ExecutionLogsPage />} />
              <Route path="/analytics" element={<AnalyticsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
